import React, { useState, useContext } from 'react';
import {
  StyleSheet,
  Text,
  View,
  Alert,
  ScrollView,
  TouchableOpacity,
  Image,
  Modal,
  ImageBackground,
  TextInput,
} from 'react-native';
import { AuthContext } from '../Contexts/ContextUsuario';
import { ProductsContext } from '../Contexts/ContextProdutos';
import { EnvioContext } from '../Contexts/ContextEnvio';

var valorTotal = 0


const ButtonChangePage = ({PaginaPerfil, PaginaInicio, PaginaSobre}) => {
  return (
    <View style={Style.ButtonsMenu}>
      <View>
      <TouchableOpacity style={Style.ButtonMenu} onPress={PaginaPerfil}>
        <Image
          style={Style.IconMenu}
          source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/804330284513492992/IconePerfil.PNG'}}
        />
      </TouchableOpacity>
      </View>

      <View>
      <TouchableOpacity style={Style.ButtonMenu} onPress={PaginaInicio}>
        <Image
          style={Style.IconMenu}
          source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/804330274862137354/IconeCasa.PNG'}}
        />
      </TouchableOpacity>
      </View>
      
      <View>
      <TouchableOpacity style={Style.ButtonMenu} onPress={PaginaSobre}>
        <Image
          style={Style.IconMenu}
          source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/811755835994275860/aboutIcon.PNG'}}
        />
      </TouchableOpacity>

      </View>
    </View>

    
  );
};

const ProdutosCarrinho = (props) => {
  const { estado, actions } = useContext(ProductsContext);

  const handleRemove = (nome) => {

    function encontraIndice(element, index, array) {
      return element.nome == nome
    }

    let newProducts = estado.cart.products;
    let indexToRemove = newProducts.findIndex(encontraIndice);
    newProducts = newProducts.splice(indexToRemove, 1);

    actions.setProducts(newProducts);
    
    alert(`${nome} removido do carrinho`)
  }

  return (
    
      <View>
      <ImageBackground style={Style.imagem} source={props.imagem}>
        <TouchableOpacity
          style={Style.ButtonCart}
          onPress={() => handleRemove(props.nome)}>
            <Image
              style={Style.IconCart}
              source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/804330288771104778/IconeRetirarCarrinho.PNG'}}
            />
        </TouchableOpacity>

      </ImageBackground>
      <View style={Style.Products}>
        <Text style={Style.nome}> {props.nome} </Text>

        <Text style={Style.preço}> {props.preço} </Text>

        
      </View>
    </View>
  );
};

const TelaCarrinho = (props) => {
  const { stateEnvio, actionsEnvio } = useContext(EnvioContext);
  const { estado } = useContext(ProductsContext);
  const { state, actions } = useContext(AuthContext); 
  const [modalVisible, setModalVisible] = useState(false);
  const [dia, setDia] = React.useState('');
  const [mês, setMês] = useState('');
  const [ano, setAno] = useState('2022');
  const [turno, setTurno] = useState('');

  var valorTotal = 0

  function PaginaPerfil() {
    props.navigation.navigate('PERFIL');
  }

  function PaginaInicio() {
    props.navigation.navigate('PAGINA INICIAL');
  }

  function PaginaSobre() {
    props.navigation.navigate('SOBRE');
  }
  console.log('tela carrinho')

  estado.cart.products.map((product) => {
    console.log(product)
    valorTotal += product.valor
  })

  // function EnviarPedido(props){
  //   if (dia == undefined || dia == null || dia == "") {
  //     Alert.alert('Data inválida')
  //   } 

  //   else if (mês == undefined || mês == null || mês == "") {
  //     Alert.alert('Data inválida')
  //   } 

  //   else if (turno == undefined || turno == null || turno == "") {
  //     Alert.alert('Data inválida')
  //   } 
    
  //   else {
  //   actionsEnvio.setEnvio({
  //     data: dia + mês + ano + " - " + turno
  //   });
  //   props.navigation.navigate("CONFIRMAR ENVIO");
  //   setModalVisible(!modalVisible);
  // }
  // }

  function BotãoEnvioManhã(){
    var turno = "Manhã"
    if (dia == undefined || dia == null || dia == "") {
      alert('Data inválida')
    } 

    else if (mês == undefined || mês == null || mês == "") {
      alert('Data inválida')
    } 

    else {
    stateEnvio.envio = {
      data: `${dia}/${mês}/${ano} - ${turno}`
    };
    props.navigation.navigate("CONFIRMAR ENVIO");
    setModalVisible(!modalVisible);
  }}
  










  function BotãoEnvioTarde(){
    console.log(`${dia}/${mês}/${ano}`)
    var turno = "Tarde"
    if (dia == undefined || dia == null || dia == "") {
      Alert.alert('Data inválida')
    } 

    else if (mês == undefined || mês == null || mês == "") {
      Alert.alert('Data inválida')
    } 

    else {
    stateEnvio.envio = {
      data: `${dia}/${mês}/${ano} - ${turno}`
    };
    props.navigation.navigate("CONFIRMAR ENVIO");
    setModalVisible(!modalVisible);
  }}

    return(
      
      <View style={{
        backgroundColor: 'rgba(179, 179, 179, 255)',
        width: '100%',
        height: '100%',
      }}>
  
        <View style={Style.Cabeçalho}>
  
        <ButtonChangePage
            PaginaPerfil={PaginaPerfil}
            PaginaInicio={PaginaInicio}
            PaginaSobre={PaginaSobre}
            
          />
          <View style={{
            flexDirection: 'row-reverse',
            marginStart: 15,
          }}>
            <Image
              style={Style.CantinaSantaClara}
              source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/809404531241779240/logoCantina.png'}}
            />
          </View>
        </View>
        
        <Text style={Style.informações}>Valor total: {valorTotal} </Text>
       
        
        <ScrollView style={Style.scrollView}>
        <View style={Style.produtosMenu}>

        {estado.cart.products.map(product => (
          <ProdutosCarrinho
            nome={product.nome}
            preço={product.preço}
            imagem={product.imagem} />
        ))}
       
        </View>
        </ScrollView>

        <View style={{
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'center',
        }}>
        <TouchableOpacity
            style={Style.ButtonEscolherData}
            onPress={() => props.navigation.navigate("DATA ENTREGA")}>

            <Text style={Style.ButtonConfirmText}> Data de entrega </Text>
          </TouchableOpacity>
          </View>

         </View>
    );
  }


const Style = StyleSheet.create({

  PreçoData: {
    width: '100%',

    flexDirection: 'row',
    justifyContent: "center",

  },

    //Pagina inicial --> Cardapio
    botões:{
     
      flexDirection: 'row',
      justifyContent: 'space-around',
  
      marginHorizontal: 20,
      width: 150,
  
      marginTop: 10,


    },

  logo: {
    height: 20,
    width: 20,
  },
  
  botão: {
    backgroundColor: 'rgba(255, 255, 255, 255)',
    borderRadius: 20,
    padding: 5,
    marginBottom: 20,
    marginTop: 10,
    marginHorizontal: 70,
    shadowColor: '#303838',
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 10,
    shadowOpacity: 0.35,
  },

    botãoConfirmar: {
    backgroundColor: 'rgba(255, 255, 255, 255)',
    borderRadius: 20,
    padding: 5,
    marginBottom: 20,
    marginTop: 10,
    marginHorizontal: 70,
    shadowColor: '#303838',
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 10,
    shadowOpacity: 0.35,
  },

  nome: {
    fontFamily: 'System',
    fontSize: 12,
    color: 'rgba(255, 255, 255, 255)',
    marginTop: 1,
  },

  preço: {
    fontFamily: 'System',
    fontSize: 12,
    color: 'rgba(255, 255, 255, 255)',
    marginTop: 1,
  },

  produtos: {
    alignItems: 'flex-start',

    paddingStart: 5,
    paddingTop: 5,

    width: 150,
    height: 90,

    borderRadius: 20,
  },

  scrollView: {
    marginTop: 20,
    marginBottom: 110,

  },

  botãoCardapio: {
    height: 30,
    width: 30,
    backgroundColor: 'rgba(255, 255, 255, 255)',
    borderRadius: 20,
    padding: 5,
    marginBottom: 20,
    marginTop: -30,
    marginHorizontal: 110,
    shadowColor: '#303838',
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 10,
    shadowOpacity: 0.35,
  },

  produtosMenu: {
    flexDirection: 'column',
    marginStart: 30,
    
  },

  imagem: {
    alignItems: 'flex-start',

    marginTop: 30,

    paddingStart: 5,
    paddingTop: 5,

    width: 150,
    height: 90,

    borderRadius: 20,
  },

  CantinaSantaClara: {
    
    width: 150,
    height: 85,
  },

  Cabeçalho: {
    flexDirection: 'column-reverse',
    width: '100%',
    height: 170,

    backgroundColor: 'rgba(0, 58, 109, 255)',
  },

  ButtonsMenu: {
    flexDirection: 'row',
    justifyContent: 'space-around',

    width: '100%',
    height: 80,

    marginTop: -10,
  },

  ButtonMenu: {
    
    flexDirection: 'row',
    justifyContent: 'center',
        

    backgroundColor: 'rgba(255, 255, 255, 255)',

    borderRadius: 50,

    padding: 7,

    marginBottom: 30,
    marginTop: 30,

    shadowColor: '#303838',
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 10,
    shadowOpacity: 0.35,
  },

  IconMenu: {
    height: 20,
    width: 20,
  },

  ButtonEscolherData: {
    justifyContent: 'center',

    width: 230,
    height: 60,

    marginTop: -90,
    borderRadius: 20,
    
    backgroundColor: 'rgba(0, 58, 109, 255)',

  },

  ButtonConfirm: {
    alignSelf: 'center',
    justifyContent: 'center',

    width: 230,
    height: 60,

    marginTop: 30,
    borderRadius: 20,
    
    backgroundColor: 'rgba(0, 58, 109, 255)',

  },

  ButtonConfirmText: {
    textAlign: 'center',

    fontFamily: 'System',
    fontSize: 25,

    color: 'rgba(255, 255, 255, 255)',
  },

  IconCart: {
    height: 20,
    width: 20,
  },

  IconCloseModal: {
    height: 15,
    width: 15,
  },

  ButtonCart: {
    backgroundColor: 'rgba(255, 255, 255, 255)',
    borderRadius: 20,

    padding: 5,

    marginBottom: 20,
    marginTop: 50,
    marginHorizontal: 110,

    shadowColor: '#303838',
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 10,
    shadowOpacity: 0.35,
  },

  ButtonFecharModal: {
    alignSelf: 'flex-start',

    backgroundColor: 'rgba(255, 255, 255, 255)',
    borderRadius: 20,

    padding: 5,

    marginTop: 10,
    marginStart: 20,
    

    shadowColor: '#303838',
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 10,
    shadowOpacity: 0.35,
  },


  informações:{
    flexDirection:'row',
    justifyContent:'center',

    width: '95%',
    height: 60,

    padding: 20,

    marginStart: '2.5%',
    marginTop: 25,

    backgroundColor: '#FFFFFF',

    borderRadius: 50,
    borderWidth: 1,
    borderColor: 'rgba(0, 58, 109, 255)',
  },

  BotãoTurnoTarde: {

    justifyContent: 'center',

    width: 90,
    height: 40,

    marginTop: 10,
    borderRadius: 20,
    
    backgroundColor: 'rgba(0, 58, 109, 255)',
  },

  BotãoTurnoManhã: {

    justifyContent: 'center',

    width: 90,
    height: 40,

    marginTop: 10,
    borderRadius: 20,
    
    backgroundColor: 'rgba(0, 58, 109, 255)',
  },

  BotãoConfirmar: {

    justifyContent: 'center',
    alignSelf: 'center',

    width: 120,
    height: 50,

    marginTop: 25,
    borderRadius: 20,
    
    backgroundColor: 'rgba(0, 58, 109, 255)',
  },

  TextoConfirmar: {

    textAlign: 'center',

    fontFamily: 'System',
    fontSize: 17,

    color: 'rgba(255, 255, 255, 255)',
  },

  TextoTurno: {

    textAlign: 'center',

    fontFamily: 'System',
    fontSize: 15,

    color: 'rgba(255, 255, 255, 255)',
  },

  LayoutModal: {
    alignSelf: 'center',
    

    width: '85%',
    height: 300,

    marginTop: 270,

    borderRadius: 20,

    backgroundColor: 'rgba(112, 112, 112, 255)',
  },

  BotõesTurno: {
    flexDirection:'row',
    justifyContent:'space-between',
    alignSelf: 'center',

    width: '70%',
    height: 50,    

  },

  ModalTitulo: {

    marginTop: 15,
    marginStart: 20,

    fontFamily: 'System',
    fontSize: 23,

    color: 'rgba(255, 255, 255, 255)',
  },

  ModalOpçãoTurno: {

    marginTop: 10,
    marginStart: 20,

    fontFamily: 'System',
    fontSize: 15,

    color: 'rgba(255, 255, 255, 255)',
  },

  LayoutData: {
    flexDirection:'row',
    justifyContent:'space-between',
    alignSelf: 'center',
    
    marginTop: 20,

    width: '70%',
    height: 50, 

  },

  InputData: {
    flexDirection:'row',
    justifyContent:'center',

    width: 70,
    height: 40,

    backgroundColor: '#FFFFFF',

    borderRadius: 50,
    borderWidth: 1,
    borderColor: 'rgba(0, 58, 109, 255)',
  },
  
  Barra: {

    marginTop: 5,

    fontFamily: 'System',
    fontSize: 20,

    color: 'rgba(255, 255, 255, 255)',

  },
  
})

export default TelaCarrinho;
